export default class LocationType
{
	static UNKNOWN = 0;

	static COUNTRY = 100;

	static ADM_LEVEL_1 = 200;
	static ADM_LEVEL_2 = 210;
	static ADM_LEVEL_3 = 220;
	static ADM_LEVEL_4 = 230;

	static LOCALITY = 300;
	static SUB_LOCALITY = 310;
	static SUB_LOCALITY_LEVEL_1 = 320;
	static SUB_LOCALITY_LEVEL_2 = 330;
	static STREET = 340;

	static BUILDING = 400;
	static ADDRESS_LINE_1 = 410;

	static FLOOR = 420;
	static ROOM = 430;

	static TMP_TYPE_HINT = 5010;
	static TMP_TYPE_CLARIFICATION = 5020;
}
